import type { PropsWithChildren } from 'react';

import { OpenFeatureProvider } from '@openfeature/react-sdk';

export const OpenFeatureBoundary = ({ children }: PropsWithChildren) => (
  <OpenFeatureProvider suspendUntilReady>{children}</OpenFeatureProvider>
);
